import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import ClientMemberProfile from "./ClientMemberProfile";
import ClientProfileApp from "./ClientProfileApp";

function ProfileSocialRedirect() {
  const { pathname, search } = useLocation();
  const base = pathname.replace(/\/$/, "");
  if (base !== "/app/profile") return null;
  const params = new URLSearchParams(search);
  if (params.get("social") === "1") {
    return <Navigate to="/app/profile/account/social" replace />;
  }
  if (params.get("payment")) {
    return (
      <Navigate
        to={`/app/profile/account/club${search}`}
        replace
      />
    );
  }
  return null;
}

export default function ClientProfileRoutes() {
  return (
    <>
      <ProfileSocialRedirect />
      <Routes>
        <Route index element={<ClientMemberProfile profileTab />} />
        <Route path="account/*" element={<ClientProfileApp />} />
        <Route path="*" element={<Navigate to="/app/profile" replace />} />
      </Routes>
    </>
  );
}
